import { render, staticRenderFns } from "./MHCoachingBookCoach.vue?vue&type=template&id=6d5fc7c7"
import script from "./MHCoachingBookCoach.vue?vue&type=script&lang=js"
export * from "./MHCoachingBookCoach.vue?vue&type=script&lang=js"
import style0 from "./MHCoachingBookCoach.vue?vue&type=style&index=0&id=6d5fc7c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports